<svelte:options
  customElement={{
    tag: "oc-tab-container-v1",
    shadow: "none",
    props: {},
  }}
/>

<script lang="ts">
  import { onMount } from "svelte";
  import type { Props } from "./TabPanelV1.types.js";

  /*                                                         */
  let props: Props = $props();

  const Host = $host();

  onMount(() => {
    /*                       */
    Host.setAttribute("role", "tabpanel");
    Host.setAttribute("aria-hidden", "true");
  });
</script>
